
function filterToggle()
{

  const openFilterButtons = document.querySelectorAll('.openfilter');
  const elementToToggle = document.getElementById("filtertoggle");
  const topButton = document.querySelector('#openfilter1');


  if (window.innerWidth <= 760) {
    document.querySelector('#openfilter2').style.display = "flex";
  }

  // Set a fixed max-height when the element is hidden
  elementToToggle.style.maxHeight = "0";
  openFilterButtons.forEach(function(openFilterButton) {
    openFilterButton.addEventListener('click', function(event) {
      event.preventDefault();

      if (elementToToggle.style.display === "none") {
        // If the element is hidden, show it with a sliding effect
        elementToToggle.style.display = "block"; // or "inline-block" based on your layout
        elementToToggle.style.maxHeight = elementToToggle.scrollHeight + "px";
        document.querySelector('#openfilter1').innerText = "Close";
        document.querySelector('#openfilter1').classList.remove("closed");
        document.querySelector('#openfilter1').classList.add("open");

        if (window.innerWidth <= 760) {
          document.querySelector('#openfilter1').style.display = "none";
        }
      } else {
          // If the element is visible, hide it
          elementToToggle.style.maxHeight = "0";
         // elementToToggle.style.display = "none";
          document.querySelector('#openfilter1').innerText = "Filters";
          document.querySelector('#openfilter1').classList.remove("open");
          document.querySelector('#openfilter1').classList.add("closed");

          if (window.innerWidth <= 760) {
            document.querySelector('#openfilter1').style.display = "block";
          }

          // After the closing animation completes, hide the element
          elementToToggle.addEventListener("transitionend", function() {
            if (elementToToggle.style.maxHeight === "0px") {
              elementToToggle.style.display = "none";
            }
          });
      } // end if else
    });
  });
}

/* 
  SEARCH INPUT
*/

function searchInput()
{
  const myInput = document.getElementById("search");
  myInput.addEventListener("input", function() {
      const inputValue = myInput.value;

      // Check if the input length is at least 3 characters
      if (inputValue.length >= 3) {
        //updateSearchListing(inputValue);
        // Create an array to hold all selected values
        const selectedItems = [];

        // Get selected values for each group and add them to the selectedItems array
        selectedItems.push(...getSelectedValues("resources-checkbox"));
        selectedItems.push(...getSelectedValues("industries-checkbox"));
        selectedItems.push(...getSelectedValues("topics-checkbox"));

        processApplySelections();
      } 

      if (inputValue.length == 0) {
        const itemList = Array.from(document.getElementById("resourcelisting").getElementsByClassName("resourcelistingitem"));
        itemList.forEach((li) => {
            li.style.display = "block"; 
        });
      }
  });
}

/* 
  APPLY FILTER
*/

function getSelectedValues(groupName) {
  const checkboxes = document.querySelectorAll(`input[name=${groupName}]:checked`);
  return Array.from(checkboxes, checkbox => checkbox.value);
}

function processSelectedItems(selectedItems) {

  const searchText = document.getElementById("search").value.toLowerCase();
  const itemList = Array.from(document.getElementById("resourcelisting").getElementsByClassName("resourcelistingitem"));
  
  let matchCount = 0;
  itemList.forEach((li) => {
      // Check if any of the IDs in the data-id attribute match the selected items or search input
      if (selectedItems.length > 0) {
        const dataId = li.getAttribute("data-tags");
        const idArray = dataId.split(',').map(id => id.trim());
        const match = idArray.some(id => selectedItems.includes(id) || id === searchText);
        if (match) {
            matchCount++;
            li.style.display = "block"; // Show the matching items
        } else {
            li.style.display = "none"; // Hide the non-matching items
        }
      } else {
        const title = li.getAttribute("data-title").toLowerCase();
        if (title.includes(searchText)) {
            matchCount++;
            li.style.display = "block"; // Show the matching items
        } else {
            li.style.display = "none"; // Hide the non-matching items
        }
      }
  });

  // Get a reference to the element with the specified class name
var element = document.querySelector('.resourcelisting-results__showing');
if (element) {
  element.textContent = `Showing ${matchCount} of ${matchCount}`;
}

}

function processApplySelections()
{
  var resourceListing = document.getElementById('resourcelisting');
  if (resourceListing) {
      resourceListing.style.display = 'grid';
  }

  var resourceResults = document.getElementById('resourcelisting-results');
  if (resourceResults) {
      resourceResults.style.display = 'block';
  }

  var elementsToHide = document.getElementsByClassName('filter-hide');
  for (var i = 0; i < elementsToHide.length; i++) {
    elementsToHide[i].style.display = 'none';
  }

  // Create an array to hold all selected values
  const selectedItems = [];
  const selectedDisplayItems = []; //new

  // Get selected values for each group and add them to the selectedItems array
  selectedItems.push(...getSelectedValues("resources-checkbox"));
  selectedItems.push(...getSelectedValues("industries-checkbox"));
  selectedItems.push(...getSelectedValues("topics-checkbox"));

  //New
  selectedDisplayItems.push(...getSelectedObjectValues("resources-checkbox"));
  selectedDisplayItems.push(...getSelectedObjectValues("topics-checkbox"));
  selectedDisplayItems.push(...getSelectedObjectValues("industries-checkbox"));
  showSelectedButtons(selectedDisplayItems);

  // Call your function and pass the combined selectedItems array
  processSelectedItems(selectedItems);
}

//New
function showSelectedButtons(data)
{
  document.getElementById('clearLink').style.display = "block";
  var resultList = document.querySelector('.resourcelisting-results__panel_list');
  if (resultList) {
    var htmlString = '';
    data.forEach(function(item) {
      htmlString += '<li class="resource-tag" data-location="' + item.location + '">' + item.value + '</li>';
      resultList.innerHTML = htmlString;

      var resourceTags = document.querySelectorAll('.resource-tag');
      resourceTags.forEach(function(tag) {
        tag.addEventListener('click', function(event) {
          // Prevent the default behavior of the anchor tag
          event.preventDefault();
          
          var dataLocation = tag.getAttribute('data-location');

          document.getElementById(dataLocation).checked = false;
          const selectedItems = [];
          selectedItems.push(...getSelectedValues("resources-checkbox"));
          selectedItems.push(...getSelectedValues("industries-checkbox"));
          selectedItems.push(...getSelectedValues("topics-checkbox"));
          processSelectedItems(selectedItems);

          var listItem = tag.closest('li');
          if (listItem) {
            listItem.remove();
          }
        });
      });
    });
  } else {
    console.error("The ul element with class 'resourcelisting-results__panel_list' was not found.");
  }
}

function getSelectedObjectValues(groupName,location) 
{
  const checkboxes = document.querySelectorAll(`input[name=${groupName}]:checked`);
  return Array.from(checkboxes, checkbox => ({
    id: checkbox.getAttribute('data-id'),
    value: checkbox.getAttribute('data-value'),
    location: checkbox.id
  }));
}

/* end new */

// end new

function applySelections()
{
  document.getElementById("applyButton").addEventListener("click", function() {

    processApplySelections();

  });
}

/* CLEAR BUTTON */

function clearFilters()
{
  // Clear the search input
  document.getElementById("search").value = "";

  // Clear the selected checkboxes (assumes checkboxes have unique IDs)
  clearSelectedCheckboxes("resources-checkbox");
  clearSelectedCheckboxes("industries-checkbox");
  clearSelectedCheckboxes("topics-checkbox");

  // Reset the list of <li> elements to their initial state
  const itemList = Array.from(document.getElementById("resourcelisting").getElementsByClassName("resourcelistingitem"));
  itemList.forEach((li) => {
      li.style.display = "block"; // Show all items
  });

  document.getElementById('clearLink').style.display = "none";

  var resultList = document.querySelector('.resourcelisting-results__panel_list');
  resultList.innerHTML = '';
}

function clearSelectedCheckboxes(groupName)
{
  const checkboxes = document.querySelectorAll(`input[name=${groupName}`);
  checkboxes.forEach(checkbox => {
      checkbox.checked = false;
  });
}

function checkboxSelection()
{
  const urlParams = new URLSearchParams(window.location.search);
  const resourceParam = urlParams.get('resources');

  if (resourceParam) {
    let resourceVar = '';
    switch (resourceParam) {
      case 'article':
        resourceVar = 'resources-checkbox0';
        break;
      case 'newsletter':
        resourceVar = 'resources-checkbox1';
        break;
      case 'vlog':
        resourceVar = 'resources-checkbox2';
        break;
      case 'ebook':
        resourceVar = 'resources-checkbox3';
        break;
    }
    document.getElementById(resourceVar).checked = true;
    processApplySelections();
  }
}

document.addEventListener('DOMContentLoaded', function() {

  const resourceDiv = document.querySelector(".resource-div");

  if (resourceDiv) {
    checkboxSelection();

    filterToggle();

    searchInput();

    applySelections();

    document.getElementById("clearButton").addEventListener("click", clearFilters);
    document.getElementById("clearLink").addEventListener("click", clearFilters); // new
  }

});